var flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts;
    $goodsTab = $('#subnav-goods-tab,#subnav-shop-tab');
    if (!($menuElem = $goodsTab.find('.ls-gcx-flyout-menu')).length) {
      return;
    }
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: '.ls-gcx-flyout-nested-links',
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass('ls-gcx-flyout-active');
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass('ls-gcx-flyout-active');
      }
    };
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find('.ls-gcx-flyout-nested-links');
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};

